export const insertText = (text) => {
    const insertTextInner = (state, dispatch) => {
        const { tr } = state;
        tr.insertText(text);
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
        return true;
    };
    return insertTextInner;
};
//# sourceMappingURL=insertText.js.map